// Write your code here.

import './index.css'

const NavBar = props => {
  const {score, topScore, showScoreCard} = props

  let ScoreCardElemnt

  if (showScoreCard) {
    ScoreCardElemnt = (
      <div className="score-card">
        <p className="score">Score: {score}</p>
        <p className="score">Top Score: {topScore}</p>
      </div>
    )
  }
  return (
    <div className="nav-bar">
      <div className="emoji-container">
        <img
          src="https://assets.ccbp.in/frontend/react-js/game-logo-img.png"
          className="emoji"
          alt="emoji logo"
        />
        <h1 className="emoji-heading">Emoji Game</h1>
      </div>
      {ScoreCardElemnt}
    </div>
  )
}

export default NavBar
